export const API_URL = "https://app.wewantwaste.co.uk/api";
